module.exports = "/static/Images/Roboto/Roboto-Thin.ttf";